module.exports = __webpack_public_path__ + "img/footer-mz.14255239.png";